import { memo } from "react";

import { Label } from "../../components/ui/label";
import Input from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { cn } from "../../utils/tailwind";

export const FormField = memo(
  ({ label, id, register, error, containerClassName, as, ...props }) => {
    const InputComponent = as === "textarea" ? Textarea : Input;

    return (
      <div className={cn("pb-1", containerClassName)}>
        <Label htmlFor={id}>{label}</Label>
        <InputComponent
          id={id}
          {...register}
          className={`w-full ${error ? "border-negative" : ""}`}
          {...props}
        />
        <div className="min-h-5">
          {error && (
            <span className="text-sm text-negative">{error.message}</span>
          )}
        </div>
      </div>
    );
  }
);

FormField.displayName = "FormField";
